import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="top"></a>
    <p>{`Cúram by Merative™ supported operating systems, prerequisites, and supported software.`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Operating systems</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Supported software</AnchorLink>
    </AnchorLinks>
    <h2>{`Operating systems`}</h2>
    <a name="operating-systems"></a>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Microsoft Windows</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Linux</AnchorLink>
    </AnchorLinks>
    <h3>{`Microsoft Windows`}</h3>
    <p>{`The Microsoft® Windows® platform is supported for designing, developing, testing, and building the application on a server.`}</p>
    <h4>{`Windows 11 Enterprise x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`23H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`24H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`25H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Windows 11 Pro x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`23H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`24H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`25H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Windows 11 Pro for Workstations x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`23H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`24H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`25H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Linux`}</h3>
    <p>{`The Linux® platform is supported for building the application on a server.`}</p>
    <h4>{`Red Hat® Enterprise Linux (RHEL) 9 x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`9.5`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`9.6`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`9.7`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Red Hat® Enterprise Linux (RHEL) 8 x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.3`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.4`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.5`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.6`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.7`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.8`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.9`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.10`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#operating-systems"
      }}>{`Back to Operating systems`}</a></p>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>
    <h2>{`Java Requirements`}</h2>
    <p>{`Details regarding Java version requirements are provided in each section where applicable. Please be aware that your Application Server license may not cover the usage of the associated JDK for development and other additional tool usage. You may need a separate JDK license for this. Alternatively you can choose to use a supported Open JDK for this purpose where listed below.`}</p>
    <h2>{`Prerequisites`}</h2>
    <h3>{`Installation`}</h3>
    <p>{`The supported platforms for the Merative™ Cúram installers are Linux and Windows.`}</p>
    <p>{`Java is required to run the Merative™ Cúram installers and the following versions are certified for this purpose.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prerequisite`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Semeru Runtime , Open or Certified Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`21 and future updates, security updates and patch releases`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle JDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`21 and future interim updates and patches`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>
    <h2>{`Supported software`}</h2>
    <a name="supported-software"></a>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#accessibility"
          }}>{`Accessibility`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#application-servers"
          }}>{`Application servers`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#databases"
          }}>{`Databases`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#development-tools"
          }}>{`Development Tools`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#reporting-and-analysis"
          }}>{`Reporting and Analysis`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#runtime-tools"
          }}>{`Runtime Tools`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#word-integration"
          }}>{`Word Integration`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#web-browsers"
          }}>{`Web browsers`}</a></p>
      </li>
    </ul>
    <h3>{`Accessibility`}</h3>
    <p>{`Cúram aligns with recognised accessibility standards, including Web Content Accessibility Guidelines (WCAG), Section 508, and EN 301 549. Alignment is defined in terms of conformance to these standards and is independent of specific assistive technologies, browsers, or devices. Assistive technologies that align with standards are expected to operate with Cúram.`}</p>
    <p>{`The assistive technologies listed below are used during accessibility validation to verify conformance.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Browser`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`NonVisual Desktop Access `}<a parentName="td" {...{
              "href": "https://www.nvaccess.org/"
            }}>{`NVDA`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any version and all associated security advisories, bug fixes, and patch releases.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Edge`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple VoiceOver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any version and future minor versions and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Google Chrome`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Application Servers`}</h3>
    <p>{`IBM Websphere Liberty is only supported on Container and Kubernetes platforms. Oracle WebLogic is only supported for standalone deployments.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM WebSphere Liberty`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`26.0.0.3 and future Fix Packs and Interim Fixes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Semeru JDK 21 and future updates, security updates and patch releases - see `}<a parentName="td" {...{
              "href": "https://www.ibm.com/support/pages/26003-websphere-application-server-liberty-26003"
            }}>{`IBM WebSphere Liberty 26.0.0.3 support details`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle WebLogic Server 14c`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(14.1.2.0.0) and all later patch sets`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 21 (and future interim updates and patches) compatible with the WebLogic Server installation is supported. Later JDK versions are not supported. `}<br /><strong parentName="td">{`Note:`}</strong>{` Oracle Database is the only database that is supported for use with Oracle WebLogic Server.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Databases`}</h3>
    <p>{`For the supported operating systems and necessary configuration information for these databases, see the database product documentation.`}</p>
    <p>{`Database-as-a-Service or Container and Kubernetes platforms are not supported on these databases.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Advanced Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12.1.1.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Cúram Reporting and Analytics is supported on DB2 version 12.1.1.0 and future mod releases and fix packs. `}<br />{`- The Cúram data warehouse can be built on this version of Db2. `}<br />{`- Reporting ETLs can be built using a technology compatible with this version of Db2. Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Standard Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12.1.1.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Starter Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12.1.1.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Community Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12.1.1.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM Db2 Community Edition is only supported for use in the development environment to aid application design, development and testing. For further details, see `}<a parentName="td" {...{
              "href": "https://www.ibm.com/docs/en/db2/12.1.0?topic=editions-db2-database-product-deployment-options#c0058536__db2_community"
            }}>{`here`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Enterprise Server Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future mod releases and fix packs>`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Cúram Reporting and Analytics is supported on DB2 version 11.5.5.0 and future mod releases and fix packs. `}<br />{`- The Cúram data warehouse can be built on this version of Db2. `}<br />{`- Reporting ETLs can be built using a technology compatible with this version of Db2. Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Advanced Enterprise Server Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Cúram Reporting and Analytics is supported on DB2 version 11.5.5.0 and future mod releases and fix packs. `}<br />{`- The Cúram data warehouse can be built on this version of Db2. `}<br />{`- Reporting ETLs can be built using a technology compatible with this version of Db2. Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Standard Edition VPC Option`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Community Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.9.0 and future mod releases and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM Db2 Community Edition is only supported for use in the development environment to aid application design, development and testing. For further details, see `}<a parentName="td" {...{
              "href": "https://www.ibm.com/docs/en/db2/11.5?topic=editions-db2-database-product-offerings#c0058536__db2_community"
            }}>{`here`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® for z/OS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`13 and future maintenance levels`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When using Cúram with Db2 for z/OS, the provided db2jcc4.jar file in the $CURAMSDEJ/drivers folder is used to access Db2 for z/OS whether access is local to z/OS or via a remote deployment. However, the level of Db2 for z/OS may have dependencies with the client JDBC driver level; therefore, see the `}<a parentName="td" {...{
              "href": "https://www.ibm.com/support/pages/node/405457"
            }}>{`IBM Data Server Driver for JDBC and SQLJ versions and Db2 for z/OS APARs`}</a>{` page for supported Db2 and JDBC levels. `}<br />{` The hardware and software requirements for Db2 13 for z/OS are detailed `}<a parentName="td" {...{
              "href": "https://www.ibm.com/docs/en/db2-for-zos/13?topic=13-hardware-software-requirements"
            }}>{`here`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle Database 19c`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(19.3) Enterprise Edition and future Release Updates (RU), release updates revision (Revision) and increments.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Only the Enterprise Edition of Oracle Database 19c is supported for Curam Reporting.`}<br />{`- See the `}<a parentName="td" {...{
              "href": "https://docs.oracle.com/en/database/oracle/oracle-database/19/"
            }}>{`Oracle Database 19c documentation site`}</a>{` for certified configuration information on this product.`}<br />{`- Curam Reporting has been certified against Oracle 19c as a source database to host the Cúram Application database and as a target database to host Reporting databases.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle AI Database 26ai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enterprise Edition (EE) and future Release Updates (RU), release updates revision (Revision) and increments.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Only the Enterprise Edition of Oracle AI Database 26ai is supported for Curam Reporting.`}<br />{`- See the `}<a parentName="td" {...{
              "href": "https://docs.oracle.com/en/database/oracle/oracle-database/26/index.html"
            }}>{`Oracle AI Database 26ai documentation site`}</a>{` for certified configuration information on this product.`}<br />{`- Curam Reporting has been certified against Oracle AI Database 26ai as a source database to host the Cúram Application database and as a target database to host Reporting databases.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle AI Database 26ai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AI Database Free and future Release Updates (RU), release updates revision (Revision) and increments.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle AI Database Free is only supported for use in the development environment to aid application design, development and testing. For further details, see `}<a parentName="td" {...{
              "href": "https://www.oracle.com/database/free/"
            }}>{`here`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`H2 Database`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2.2.224`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`H2 is only supported for use in the development environment to aid application design, development and testing. The supported platform is Windows 11. H2 is not supported for use with IBM Websphere Application Server or Oracle WebLogic Server. See the `}<a parentName="td" {...{
              "href": "http://www.h2database.com/html/main.html"
            }}>{`H2 site`}</a>{` for further information about system requirements, Java support and technical support.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Development Tools`}</h3>
    <p>{`Note that the development of the application is restricted to the Windows platform (Windows 11) and the listed tools have been tested only on that platform.`}</p>
    <p>{`Although technical support is not provided for any Integrated Development Environment (IDE) it should be possible to use any Java IDE for development. Support for IDEs should be sought from the relevant software vendor. The Eclipse IDE has been tested and it’s use is described in the documentation.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apache Ant`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.10.15`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Please note that only Apache Ant 1.10.15 is supported. Associated fix packs are not.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eclipse IDE for Enterprise Java and Web Developers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2026‑03 R and future micro/patch releases and qualifier builds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Available to download from `}<a parentName="td" {...{
              "href": "https://www.eclipse.org/downloads/packages/release/2026-03/r"
            }}>{`Eclipse 2026‑03 R`}</a>{`. Certified with the following version of Tomcat: Apache Tomcat `}<a parentName="td" {...{
              "href": "https://archive.apache.org/dist/tomcat/tomcat-9/v9.0.117/"
            }}>{`9.0.117`}</a>{` and with the Eclipse Tomcat Plugin version 9.1.8 downloaded from the Eclipse MarketPlace.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rational Software Architect Designer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10.0 and future modfications and fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Recommended version for the Windows 11 platform`}</strong>{`. Supported as a Modeling Environment.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Java`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Semeru JDK 21 and future updates, security updates and patch releases`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Can be used for Cúram Development.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle JDK 21 and future interim updates and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Can be used for Cúram Development.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Reporting and Analysis`}</h3>
    <p>{`Eclipse Business Intelligent and Reporting Tools (BIRT) is an open source component that provides a development and execution environment for Cúram Business Intelligence (BI) content.`}</p>
    <p>{`The use of a second Eclipse instance for BIRT development is recommended as standard Cúram development often requires an Eclipse version that is not compatible with the certified BIRT development environment.`}</p>
    <p>{`For more information, see the Development Environment Installation Guide and the BIRT Developer Guide.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eclipse Business Intelligence and Reporting Tools`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4.20.0 and future micros and qualifiers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cúram uses the all-in-one installation. For more information, see `}<a parentName="td" {...{
              "href": "https://download.eclipse.org/birt/downloads/drops/"
            }}>{`BIRT versions and platform support`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Runtime Tools`}</h3>
    <p>{`The Cúram Batch Launcher and XML Server are designed to be run as standalone Java® programs outside of an Application Server.`}</p>
    <p>{`While every effort is made to ensure that these Java® programs are compatible with all JREs, only the JREs listed below are officially supported.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Semeru JDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`21 and future updates, security updates and patch releases`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Word Integration`}</h3>
    <p>{`The Microsoft Word integration functionality for Google Chrome and Microsoft Edge is based around the extension and native messaging features of those browsers.`}</p>
    <p>{`Java is required to run the Word Integration Assistant client desktop Java™ application which is part of the Word Integration
feature. The Java versions specified in the table below are certified for this purpose.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Adoptium Eclipse Temurin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`21 and future interim updates and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Adoptium Eclipse Temurin JDK 21.0 is available as a free download from the `}<a parentName="td" {...{
              "href": "https://adoptium.net"
            }}>{`Adoptium Home Page`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Word`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2021 and future maintenace updates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for creating and editing Cúram communication documents in Microsoft Word format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Word`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2024 and future maintenace updates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for creating and editing Cúram communication documents in Microsoft Word format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Word for Microsoft 365 (included in Microsoft 365 Apps for enterprise)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Current channel and future updates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for creating and editing Cúram communication documents in Microsoft Word format as part of a Microsoft 365 Apps for enterprise subscription.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Web Browsers`}</h3>
    <p>{`The minimum recommended resolution is 1366x768. The optimum DPI setting is Normal size.`}</p>
    <p>{`Chrome, Firefox, Edge, and Safari release new versions frequently and install updates automatically by default. Merative Cúram releases (V.R.M.F releases only) are generally tested on the latest version (for Chrome and Edge, stable releases only) of these browsers available at the start of the development cycle; if tested with no issues Merative will certify that version. The prerequisites advise the version that is certified at each new product release. If for any reason, Merative Cúram are unable to certify for that version, it may be necessary to revert back to a version that is previously fully certified. While Merative will support customers on newer versions of these browsers than the last certified version, they should understand that they have not been fully tested.`}</p>
    <h4>{`Standard desktop browser support`}</h4>
    <p>{`While every effort is made to ensure that internal case worker application pages use standard web technologies and formats that are compatible with all browsers, only the listed browsers are officially supported.`}</p>
    <h4>{`Universal Access desktop browser support`}</h4>
    <p>{`Universal Access has been specifically developed for public facing applications so browser support has been extended in this area.`}</p>
    <ul>
      <li parentName="ul">{`For information about browser support for the Universal Access Responsive Web Application, see the prerequisites and supported software in the `}<a parentName="li" {...{
          "href": "/wh-support-docs/spm/pdf-documentation#citizen-engagement"
        }}>{`Universal Access Responsive Web Application documentation`}</a>{`.`}</li>
      <li parentName="ul">{`While every effort is made to ensure that the classic Universal Access application uses standard web technologies and formats that are compatible with all browsers, only the listed browsers are officially supported.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Google Chrome`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`148 and future minor versions, builds and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported for both the Universal Access and Case Worker applications. Microsoft Word Integration  and Arabic (RTL) are supported for this browser in the Case Worker application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Edge`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`147 and future minor versions, builds and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported for both the Universal Access and Case Worker applications. Microsoft Word Integration  and Arabic (RTL) are supported for this browser in the Case Worker application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Mozilla Firefox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`150 and future minor versions and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported only for the Universal Access application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple Safari`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`26 and future minor versions and patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported only for the Universal Access application.`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Tablet browser support`}</h4>
    <p>{`Google Chrome 148 and future minor versions, builds and patches are supported for tablet devices.`}</p>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      